import { render } from "./WarehouseDatatableTDMaterialQuantities.vue?vue&type=template&id=70cb75be"
import script from "./WarehouseDatatableTDMaterialQuantities.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDMaterialQuantities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__